<img mat-card-image class="rounded-circle my-auto dea-shadow" width="{{size}}" height="{{size}}" loading="{{loading}}"
  [src]="scr | cache | async" (error)="onThumbnailError($event)" crossorigin="anonymous">